import axios from "axios";
import IAddManuallyForm from "../models/IAddManuallyForm";
import IAddManualCardsForm from "../models/IAddManualCardsForm";
import IManualTransactionForm from "../models/IManualTransactionForm";
import { createSearchParams } from "react-router-dom";

export type TicketPriceResponse = {
  ticketPrice: number | null;
};

export type SaveManualTransactionSkipReason = "club_membership_required";

export type SaveManualTransactionResponse =
  | { ok: true; persisted: true }
  | {
      ok: false;
      persisted: false;
      skipReason: SaveManualTransactionSkipReason;
    };

export type AddManualCardsResponse = { cardNumbers: number[] };

export async function getSignature(data: IAddManuallyForm) {
  return await axios.get(
    `${process.env.REACT_APP_API_URL}/signature?${createSearchParams(
      data as any
    )}`
  );
}

export async function syncTransactionsForPhone(phone: string) {
  return await axios.get(
    `${process.env.REACT_APP_API_URL}/sync-transactions?phone=${phone}`
  );
}

export async function getTicketPrice() {
  return await axios.get<TicketPriceResponse>(
    `${process.env.REACT_APP_API_URL}/ticket-price`
  );
}

export async function createManualTransaction(data: IManualTransactionForm) {
  return await axios.post<SaveManualTransactionResponse>(
    `${process.env.REACT_APP_API_URL}/manual-transaction`,
    data
  );
}

export async function addManualCards(data: IAddManualCardsForm) {
  return await axios.post<AddManualCardsResponse>(
    `${process.env.REACT_APP_API_URL}/manual-cards`,
    data
  );
}
